<template>
    <Head title="Login" />
    <div class="p-6 min-h-screen flex justify-center items-center light">
        <flash-messages />
        <div class="w-full max-w-md">
            <Link :href="route('home')">
            <logo class="block w-48 mx-auto fill-white" />
            </Link>
            <form
                class="auth mt-8 bg-white dark:bg-slate-900 border border-gray-100 rounded-lg shadow-xl overflow-hidden"
                @submit.prevent="login">
                <div class="pr-5 pl-8 py-5">
                    <h2 class="text-center font-bold text-xl">{{ __('Login') }}</h2>
                    <div class="mx-auto mt-2 w-24 border-b" />
                    <text-input v-model="form.email" :error="form.errors.email" class="mt-10 pr-10" label="Email" type="email"
                        autofocus autocapitalize="off" />

                      <!-- Password input with toggle button -->
                    <div class="relative mt-6">
                        <text-input
                            v-model="form.password"
                            :error="form.errors.password"
                            label="Password"
                            :type="passwordFieldType"
                            class="pr-10"
                        />
                        <button
                            type="button"
                            @click="togglePasswordVisibility"
                            class="absolute right-3 top-8 flex items-center text-sm leading-5 focus:outline-none"
                        >
                            <!-- Eye icon for show password -->
                            <svg v-if="passwordFieldType === 'password'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500 hover:text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                            </svg>
                            <!-- Slash-eye icon for hide password -->
                            <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500 hover:text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                                <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                            </svg>
                        </button>
                    </div>

                    <label class="mt-6 select-none flex items-center" for="remember">
                        <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
                        <span class="text-sm">Remember Me</span>
                    </label>
                    <div class="flex justify-center items-center pt-4">
                        <vue-recaptcha v-if="site_key" :sitekey="site_key" size="normal" theme="light"
                            @verify="recaptchaVerified" @expire="recaptchaExpired" @fail="recaptchaFailed"
                            @error="recaptchaError" ref="vueRecaptcha">
                        </vue-recaptcha>
                    </div>
                    <loading-button :disabled="disable_login_button && site_key" :loading="form.processing"
                        class="ml-auto btn-indigo w-full items-center justify-center mt-4" type="submit"
                        :class="{ 'opacity-50 cursor-not-allowed': disable_login_button && site_key }">{{ __('Login')
                        }}</loading-button>
                    <div class="mt-5 flex justify-center">
                        <Link class="ml-2" :href="route('password.reset')">{{ __('Forgot your password?') }}</Link>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Head, Link } from '@inertiajs/vue3'
import FlashMessages from '@/Shared/FlashMessages'
import vueRecaptcha from 'vue3-recaptcha2';

export default {
    metaInfo: { title: 'Login' },
    components: {
        FlashMessages,
        LoadingButton,
        Logo,
        TextInput,
        Head,
        Link,
        vueRecaptcha,
    },
    props: {
        is_demo: Number,
        site_key: String
    },
    data() {
        return {
            loadingTimeout: 30000,
            disable_login_button: true,
            // New data property to control password input type
            passwordFieldType: 'password',
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            }),
        }
    },
    methods: {
        recaptchaVerified(response) {
            this.disable_login_button = false
            console.log(response)
        },
        recaptchaExpired() {
            this.$refs.vueRecaptcha.reset();
        },
        recaptchaFailed() {
        },
        recaptchaError(reason) {
            console.log(reason)
        },
        login() {
            this.form.post(this.route('login.store'))
        },
        autofillLogin(e, role, login) {
            e.preventDefault()
            const roleEmails = { 'admin': 'john.due.helo@mail.com', 'manager': 'robert.slaughter@mail.com', 'customer': 'mmarks@example.com' }
            this.form.email = roleEmails[role]
            this.form.password = 'w3bd.com'
            if (login) {
                this.login();
            }
        },
        // New method to toggle password visibility
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        }
    }
}
</script>
